import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

// material-ui
import { Box, InputAdornment, TextField, Typography } from '@mui/material';
import logo from '../../../assets/images/sentinel_logo.jpg';

// third party
// import {
//   // useSelector,
//   // useDispatch
// } from 'react-redux';

// project import
// import SearchSection from './SearchSection';
import ProfileSection from './ProfileSection';
// import NotificationSection from './NotificationSection';
// import * as actionTypes from 'store/actions';

// assets
// import { KeyboardArrowDown } from '@mui/icons-material';
// import { Link } from 'react-router-dom';
// import { useLocation } from 'react-router-dom';
import DatePickerStore from 'views/Stores/Insight/Calendar';
import { Download } from '@mui/icons-material';
import { CSVLink } from 'react-csv';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
// import { useLocation } from 'react-router-dom';
// import DatePickerStore from 'views/Stores/Insight/Calendar';
// import ContactSupportIcon from '@mui/icons-material/ContactSupport';
// import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import CircleNotificationsOutlinedIcon from '@mui/icons-material/CircleNotificationsOutlined';
import SearchIcon from '@mui/icons-material/Search';

const Header = () => {
  // const theme = useTheme();
  const pad = (num) => String(num).padStart(2, '0');

  const currentDate = useSelector((state) => state.customization.currentDate);
  const [selectedDate, setSelectedDate] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);

  console.log('current date is ', currentDate);

  useEffect(() => {
    const formattedDate = dayjs(currentDate).format('DD/MM/YYYY');
    setSelectedDate(formattedDate);
  }, [currentDate]);

  const prepareExportData = () => {
    const dataForExport = [];
    return dataForExport;
  };

  // const handleMenuClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // const location = useLocation();
  // const isEvidencePage = location.pathname === '/main/stores/evidence';

  const menu = (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleMenuClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      PaperProps={{
        style: {
          marginTop: '4px'
        }
      }}
    >
      <MenuItem onClick={handleMenuClose}>
        <a
          href={`http://127.0.0.1:8000/download/evidence?date=${selectedDate}`}
          target="_blank"
          rel="noreferrer"
          className="w-28 flex items-center"
        >
          <Download className="mr-2" /> ZIP
        </a>
      </MenuItem>
      <MenuItem onClick={handleMenuClose}>
        <CSVLink
          data={prepareExportData()}
          filename={`analysis_data_${new Date().getFullYear()}${pad(new Date().getMonth() + 1)}${pad(new Date().getDate())}${pad(
            new Date().getHours()
          )}${pad(new Date().getMinutes())}${pad(new Date().getSeconds())}.csv`}
          target="_blank"
          className="w-full flex items-center"
        >
          <Download className="mr-2" /> .xls
        </CSVLink>
      </MenuItem>
    </Menu>
  );

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          alignItems: 'center',
          justifyContent: 'space-between',
          py: 2,
          px: { xs: 1.5, sm: 3, md: 4 }, // Adjusted padding
          maxWidth: '1200px',
          marginRight: 'auto',
          marginLeft: -3,
          height: '64px'
        }}
      >
        {/* Left section - Logo and Contact Us */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: { xs: 1, sm: 2, md: 4 }, // Reduced gap for medium screens
            height: '100%',
            ml: 0,
            pl: 0
          }}
        >
          {/* Logo section */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              height: '100%',
              pl: 0
            }}
          >
            <img
              className="black cursor-pointer"
              src={logo}
              alt="logo"
              style={{
                width: 'clamp(25px, 4vw, 35px)', // Slightly reduced max size
                height: 'clamp(22px, 3.5vw, 30px)', // Slightly reduced max size
                objectFit: 'contain'
              }}
              onClick={() => window.open('/main/stores/storeinsight', '_self')}
            />

            <Typography
              onClick={() => window.open('/main/stores/storeinsight', '_self')}
              variant="h2"
              component="span"
              className="black cursor-pointer"
              sx={{
                fontSize: 'clamp(1rem, 2vw, 1.5rem)', // Slightly reduced font size
                paddingLeft: { xs: 0.5, sm: 1 }, // Reduced padding
                whiteSpace: 'nowrap',
                display: 'block'
              }}
            >
              Sentinel
            </Typography>
          </Box>

          {/* search bar */}
          <Box sx={{ flex: 1, display: 'flex', px: { xs: 1, sm: 2, md: 4 }, ml: 50 }}>
            <TextField
              className="w-96"
              variant="outlined"
              placeholder="Search here"
              size="small"
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '24px',
                  backgroundColor: 'white',
                  '&:hover fieldset': { borderColor: '#2196f3' },
                  '&.Mui-focused fieldset': { borderColor: '#2196f3' }
                }
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: 'gray' }} />
                  </InputAdornment>
                )
              }}
            />
          </Box>

          {/* Contact Us */}
          {/* <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              height: '100%'
            }}
          >
            <IconButton
              href="https://neophyte.ai"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: { xs: 'flex', sm: 'none' },
                color: 'text.primary',
                padding: '4px' // Reduced padding
              }}
            >
              <ContactSupportIcon />
            </IconButton>

            <Box
              sx={{
                display: { xs: 'none', sm: 'block' }
              }}
            >
              <a
                href="https://neophyte.ai"
                className="text-black hover:border-b-2 hover:border-emerald-500 hover:text-emerald-600 transition-colors duration-200 font-bold"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  fontSize: 'clamp(0.75rem, 1.2vw, 1.125rem)',
                  whiteSpace: 'nowrap',
                  textDecoration: 'none'
                }}
              >
                Contact Us
              </a>
            </Box>
          </Box> */}
        </Box>

        {/* Right section */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: { xs: 2, sm: 2, md: 3 },
            height: '100%',
            mr: { xs: 1, sm: 1, xl: -80 } // Keeping the original margin
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: { xs: 2, sm: 2, md: 3, xl: 2 }, // Reduced gap at xl breakpoint
              flexShrink: 0,
              '& > *:not(:last-child)': {
                // Target all direct children except the last one
                marginRight: { xl: '8px' } // Add specific spacing at xl breakpoint
              }
            }}
          >
            <Box
              sx={{
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                flexShrink: 0,
                right: 30
                // marginLeft: { md: '12px', xl: '24px' } // Add specific spacing at xl breakpoint
              }}
            >
              <div className="flex items-center gap-2">
                <DatePickerStore
                  sx={{
                    '& .MuiInputBase-root': {
                      height: '40px',
                      fontSize: { xs: '0.75rem', sm: '0.75rem', xl: '1rem' },
                      width: { xs: '120px', sm: '120px', xl: '160px' }
                    }
                  }}
                />
                <CircleNotificationsOutlinedIcon className="text-3xl cursor-pointer transition-transform duration-200 hover:scale-110 hover:text-blue-500" />
                <ProfileSection />
              </div>
            </Box>
            {/* </Button> */}
            {menu}
          </Box>
        </Box>
      </Box>
    </>
  );
};

Header.propTypes = {
  drawerToggle: PropTypes.func
};

export default Header;
